import { Component, OnInit, Input } from '@angular/core';

import { ILink } from './link';

@Component({
  selector: 'db-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit, ILink {
  @Input('linkTitle') linkTitle: string;
  @Input('linkUrl') linkUrl: string;

  constructor() { }

  ngOnInit() {
  }

}
